"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconVisitClubThematic = void 0;
var React = __importStar(require("react"));
var IconVisitClubThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M17.0142,19.5 L17.0142,4.5 C17.0142,3.673 16.3642,3 15.5642,3 L3.9942,3 L3.9942,21 L15.5642,21 C16.3642,21 17.0142,20.327 17.0142,19.5 Z M18.0092,13.439 L19.8122,5.828 L18.0092,5.194 L18.0092,13.439 Z M21.0002,5.172 L18.0092,17.561 L18.0092,19.5 C18.0092,20.879 16.9122,22 15.5642,22 L3.0002,22 L3.0002,2 L15.5642,2 C16.7872,2 17.7942,2.926 17.9722,4.127 L21.0002,5.172 Z M15.5,16 C15.776,16 16,16.224 16,16.5 C16,16.776 15.776,17 15.5,17 L5.5,17 C5.224,17 5,16.776 5,16.5 C5,16.224 5.224,16 5.5,16 L15.5,16 Z M14.5,18 C14.776,18 15,18.224 15,18.5 C15,18.776 14.776,19 14.5,19 L6.5,19 C6.224,19 6,18.776 6,18.5 C6,18.224 6.224,18 6.5,18 L14.5,18 Z M8.584,6.5771 C7.766,7.1151 7.197,7.9891 7.051,9.0001 L8.026,9.0001 C8.08,8.0641 8.276,7.2371 8.584,6.5771 Z M13.949,9.0001 C13.803,7.9891 13.234,7.1151 12.416,6.5771 C12.724,7.2371 12.92,8.0641 12.974,9.0001 L13.949,9.0001 Z M12.416,12.4231 C13.234,11.8851 13.803,11.0111 13.949,10.0001 L12.974,10.0001 C12.92,10.9351 12.724,11.7631 12.416,12.4231 Z M11.976,10.0001 L9.024,10.0001 C9.143,11.7441 9.853,13.0001 10.5,13.0001 C11.147,13.0001 11.857,11.7441 11.976,10.0001 Z M10.5,6.0001 C9.853,6.0001 9.143,7.2561 9.024,9.0001 L11.976,9.0001 C11.857,7.2561 11.147,6.0001 10.5,6.0001 Z M7.051,10.0001 C7.197,11.0111 7.766,11.8851 8.584,12.4231 C8.276,11.7631 8.08,10.9351 8.026,10.0001 L7.051,10.0001 Z M10.5,14.0001 C8.019,14.0001 6,11.9811 6,9.5001 C6,7.0181 8.019,5.0001 10.5,5.0001 C12.981,5.0001 15,7.0181 15,9.5001 C15,11.9811 12.981,14.0001 10.5,14.0001 Z" }))); };
exports.IconVisitClubThematic = IconVisitClubThematic;
exports.IconVisitClubThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconVisitClubThematic;
